import { FETCH_BATCH_ORDER_BY_ID_FAILURE, FETCH_BATCH_ORDER_BY_ID_REQUEST, FETCH_BATCH_ORDER_BY_ID_REST, FETCH_BATCH_ORDER_BY_ID_SUCCESS } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const getBatchOrderByIdReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_BATCH_ORDER_BY_ID_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case FETCH_BATCH_ORDER_BY_ID_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, data: null, error: null });
        case FETCH_BATCH_ORDER_BY_ID_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case FETCH_BATCH_ORDER_BY_ID_REST:
            return Object.assign(Object.assign({}, state), { loading: false, data: null });
        default:
            return state;
    }
};
export default getBatchOrderByIdReducer;
